import axios, { AxiosResponse } from "axios";
import { LicenseListItemResponse, LicenseDetailsResponse } from "../../models/SubscriptionLicenses";
import { GetPageRequest } from "../../models/PageRequest";

export const getLicenseDetails =
	(productId: string, subscriptionId: string, licenseId: string) =>
	async (): Promise<AxiosResponse<LicenseDetailsResponse>> => {
		return await axios.get(`/api/v1/${productId}/subscriptions/${subscriptionId}/licenses/${licenseId}`);
	};

export const getLicenseList =
	(productId: string, subscriptionId: string, getPageRequest: GetPageRequest) =>
	async (): Promise<AxiosResponse<LicenseListItemResponse[]>> => {
		return await axios.post(`/api/v1/${productId}/subscriptions/${subscriptionId}/licenses/page`, getPageRequest);
	};
